module.exports = __webpack_public_path__ + "img/facebook.d7239d5e.svg";